// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { OAuthScope } from '@/account/api/get-connected-applications';

export const CONNECTED_APPLICATIONS_QUERY_KEY = ['connected-applications'];

export const OAUTH_SCOPE_DISPLAY: Record<
  OAuthScope,
  { label: string; description: string }
> = {
  'hardfin:read': {
    label: 'Read',
    description: "View the organization's data through the Hardfin API",
  },
  'hardfin:write': {
    label: 'Change',
    description:
      "Create, update and delete the organization's data through the Hardfin API",
  },
  offline_access: {
    label: 'Stay signed in',
    description:
      'Keep its access without asking again, until its session ends or is signed out',
  },
};
